<template>
  <Modal :id="'cmp-main_app-account-details'" @cancelled="onCancel">
    <template slot="header">Account Details</template>

    <template slot="body">
      <!-- <ROInput
        v-if="account.user"
        :value="account.user.user_name"
        :label="'Username'"
      >
      </ROInput> -->
      <!-- <TextField
        class="m1"
        :id="'Username'"
        required
        v-bind="textFieldConfig"
        :value="account.user.user_name"
        :placeholder="'Username'"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <TextField
          class="m1"
          :id="'password'"
          required
          :password="true"
          v-bind="textFieldConfig"
          :value="account.user.password"
          :placeholder="'Password'"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      <TextField
          class="m1"
          :id="'staff_email'"
          required
          v-bind="textFieldConfig"
          :value="account.user.staff_email"
          :placeholder="'Email'"
          @valuechanged="onTextFieldValueChange"
        ></TextField> -->
      <TextField
        class="m1"
        :id="'job_title'"
        required
        v-bind="textFieldConfig"
        :value="account.user.job_title"
        :placeholder="'Job Title'"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <TextField
        class="m1"
        :id="'staff_fullname'"
        required
        v-bind="textFieldConfig"
        :value="account.user.staff_fullname"
        :placeholder="'Name'"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <TextField
        class="m1"
        :id="'staff_phone1'"
        required
        v-bind="textFieldConfig"
        :value="account.user.staff_phone1"
        :placeholder="'Phone'"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <TextField
        class="m1"
        :id="'staff_phone2'"
        required
        v-bind="textFieldConfig"
        :value="account.user.staff_phone2"
        :placeholder="'Mobile'"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <!-- <div class="dt-readonly-form">
        <div class="dt-readonly-form--input">
          <div class="dt-readonly-form--label">Username</div>
          <div class="dt-readonly-form--control">
            <div
              class="dt-readonly-form--value"
              v-if="account && account.user"
            >{{account.user.user_name}}</div>
            <div class="dt-readonly-form--options">
              <div class="dt-readonly-form--change">Change Username</div>
            </div>
          </div>
        </div>
      </div> -->
    </template>

    <template slot="options">
      <!-- <button class="dt-button v1 s6" @click.stop="onUpdate">Update</button> -->
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import { mapGetters, mapActions } from "vuex";
import ROInput from "@plugins/text-field/ro-input";
import { createTextFieldConfig, EventHooks } from "../../plugins/text-field";
import * as ActionTypes from "../../store/app/account/types";

export default {
  components: {
    Modal,
    ROInput,
  },
  mounted: function () {},
  data: function () {
    return {
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        controlStyle: "readonly",
        showValidationIcons: false,

        valueChangedEvent: EventHooks.OnBlur,
      }),
    };
  },
  computed: {
    ...mapGetters({
      account: "account",
    }),
  },
  methods: {
    ...mapActions({
      [ActionTypes.UPDATE_ACCOUNT_INFO]: ActionTypes.UPDATE_ACCOUNT_INFO,
    }),
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (name, value) {
      this[ActionTypes.UPDATE_ACCOUNT_INFO]({
        name,
        value,
        user: this.account.user,
      });
    },
    onUpdate: function () {},
    //MARK: Methods
  },
};
</script>

<style lang="scss">
</style>
